import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export enum PermissionGroupEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export class IPostUserInsurancePermissionsBodyDto {
  userId: number;
  insurenceId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IPatchUserInsurancePermissionsBodyDto {
  insurenceId: number;
  permissionGroup: PermissionGroupEnum;
}

export class UserInsurancePermission {
  id: number;
  userId: number;
  insurenceId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IUserInsurancePermissionResponse {
  @Type(() => UserInsurancePermission)
  result: UserInsurancePermission;
}

export class IUserInsurancePermissionListResponse extends IPagination {
  @Type(() => UserInsurancePermission)
  results: UserInsurancePermission[];
}

export class IUserInsurancePermissionsQueryDto extends IQueryPaginationDto {
  userId?: string;
}
